<template>
  <div
    style="display: flex; flex-direction: column; height: calc(100vh - 180px)"
  >
    <div style="display: flex; flex-wrap: wrap">
      <div class="condition-item">
        <label class="fn-14">订单号</label>
        <el-input
          v-model="searchObj.orderNo"
          placeholder="请输入订单号"
          autocomplete="off"
          size="small"
        ></el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">学校名称</label>
        <el-input
          v-model="searchObj.schoolName"
          placeholder="请输入学校名称"
          autocomplete="off"
          size="small"
        ></el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">手机号码</label>
        <el-input
          v-model="searchObj.mobileNumber"
          placeholder="请输入手机号码"
          autocomplete="off"
          size="small"
        ></el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">学号</label>
        <el-input
          v-model="searchObj.studentCode"
          placeholder="请输入学号"
          autocomplete="off"
          size="small"
        ></el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">创建云盘时间</label>
        <el-date-picker
          v-model="searchObj.startTime"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
        <label class="fn-14" style="padding-left: 10px">-</label>
        <el-date-picker
          v-model="searchObj.endTime"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
      </div>
      <div class="condition-item">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
          size="small"
          >查询
        </el-button>
      </div>
    </div>
    <div style="margin-bottom: 15px; flex: 1; overflow: hidden">
      <el-table
        :data="taskList"
        v-loading="tableLoading"
        stripe
        border
        height="100%"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <template #empty>
          <p>{{ tableLoading == true ? "数据加载中" : "暂无数据" }}</p>
        </template>
        <el-table-column
          prop="orderNo"
          label="订单号"
          width="180"
          fixed
        ></el-table-column>
        <el-table-column
          prop="studentName"
          label="姓名"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="mobileNumber"
          label="手机号码"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="shotTypeCode"
          label="采集类型"
          align="center"
          min-width="90"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.shotTypeCode == 0"
              type="success"
              size="small"
              effect="plain"
              >校拍</el-tag
            >
            <el-tag
              v-else-if="scope.row.shotTypeCode == 1"
              type="danger"
              size="small"
              effect="plain"
              >散拍</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="studentCode"
          label="学号"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="schoolCode"
          label="院校代码"
          min-width="90"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建云盘账号时间"
          align="center"
          :formatter="columnDateFormat"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="syncYunStatus"
          label="同步状态"
          align="center"
          min-width="90"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.syncYunStatus === 0"
              type="info"
              effect="plain"
              size="small"
              >未同步</el-tag
            >
            <el-tag
              v-else-if="scope.row.syncYunStatus === 1"
              type="success"
              size="small"
              effect="plain"
              >同步成功</el-tag
            >
            <el-tag
              v-else-if="scope.row.syncYunStatus === 2"
              type="warning"
              size="small"
              effect="plain"
              >同步失败</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="permission.asyncReload"
              @click.stop="handleAsyncReload(scope.row)"
              >同步文件</el-button
            >
            <el-button
              type="text"
              v-if="permission.info"
              @click.stop="handleView(scope.row)"
              >学生信息</el-button
            >

            <el-button
              type="text"
              v-if="permission.syncLog"
              @click.stop="handleLogs(scope.row)"
              >同步日志</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="display: flex; justify-content: right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageConf.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageConf.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageConf.total"
      >
      </el-pagination>
    </div>
    <orderinfo ref="orderInfoFrom" />
    <logsViews ref="logs" />
  </div>
</template>
<script>
import { queryOrders } from "@/api/yunpan";
import { reSyncOrder } from "@/api/order";
import { dateFormat } from "@/utils/date";
import { queryPageButton } from "@/api/permission";
import orderinfo from "@/components/orderinfo.vue";
import logsViews from "./extend/logsViews.vue";
export default {
  name: "photoSyncRecordList",
  components: {
    orderinfo, //查看详情
    logsViews,
  },
  data() {
    return {
      tableLoading: false,
      taskList: [],
      searchObj: {
        schoolName: "",
        mobileNumber: "",
        studentCode: "",
        startTime: "",
        endTime: "",
        orderNo: "",
      },
      pageConf: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      permission: {
        info: false,
        syncLog: false,
        asyncReload: false,
      },
    };
  },
  methods: {
    //查询
    handleSearch() {
      this.pageConf.page = 1;
      this.queryList();
    },

    //分页
    handleCurrentChange(val) {
      this.pageConf.page = val;
      this.queryList();
    },
    //显示条数
    handleSizeChange(val) {
      this.pageConf.pageSize = val;
      this.queryList();
    },
    columnDateFormat(row, column, cellValue, index) {
      const dateValue = row[column.property];
      if (dateValue != null) {
        return dateFormat("YYYY-mm-dd HH:MM:SS", new Date(dateValue));
      }
    },
    //查询列表
    async queryList() {
      const { page, pageSize } = this.pageConf;
      const data = {
        ...this.searchObj,
      };
      this.tableLoading = true;
      const res = await queryOrders(data, page, pageSize);
      this.taskList = res.data.content;
      this.pageConf.total = res.data.totalElements;
      this.tableLoading = false;
    },
    //按钮权限
    async queryButton() {
      const resp = await queryPageButton(255);
      for (const button of resp.data) {
        if (button.code === "viewStudentInfo") {
          this.permission.info = true;
        }
        if (button.code === "viewLogs") {
          this.permission.syncLog = true;
        }
        if (button.code === "asyncReload") {
          this.permission.asyncReload = true;
        }
      }
    },
    //查看学生信息
    handleView(record) {
      if (this.$refs.orderInfoFrom != undefined) {
        this.$refs.orderInfoFrom.initData(record.id, "xp");
      }
    },
    //同步订单
    async handleAsyncReload(record) {
      this.$confirm("是否执行此操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.finishedLoading = true;
          reSyncOrder({ id: record.id })
            .then((resp) => {
              this.$notify({
                title: "操作",
                message: resp.message,
                type: "success",
              });
              // this.finishedLoading = false;
              this.pageConf.page = 1;
              this.queryList();
            })
            .catch((error) => {});
        })
        .catch(() => {});
    },
    //查看日志
    handleLogs(record) {
      if (this.$refs.logs != undefined) {
        this.$refs.logs.initData(record.id);
      }
    },
  },
  created() {},
  mounted() {
    //查询
    this.queryList();
    this.queryButton();
  },
};
</script>
